import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const SelectJobStyle = makeStyles({
  customModal: {
    "& .MuiTableContainer-root": {
      maxHeight: "500px",
      height: "100%",
    },
    "& .MuiDialog-paperWidthSm": {
      boxShadow: "0 5px 8px 0 rgba(0, 0, 0, 0.24)",
      padding: "36px 40px 40px",
      maxWidth: "1200px",
      width: "100%",
      "@media (max-width: 991px)": {
        maxWidth: "100%",
        padding: "20px 15px",
        margin: "30px 15px",
        height: "100%",
      },
      "& .MuiDialogTitle-root": {
        padding: "0",
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "20px",
      },
      "& .MuiDialogContent-root": {
        padding: "0",
        overflow: "hidden",
      },
      "& h2": {
        fontSize: "24px",
        fontWeight: "700",
        lineHeight: "40px",
      },
    },
    "& .close-modal": {
      position: "absolute",
      right: "40px",
      top: "40px",
      cursor: "pointer",
      "@media (max-width: 991px)": {
        top: "28px",
        right: "25px",
      },
    },
    "& .MuiFormControl-root": {
      "& > div": {
        "&::after": {
          display: "none",
        },
      },
    },
    "& .MuiInputBase-root.MuiInput-root": {
      border: "none",
      "& input": {
        border: "none",
      },
    },
    "& .MuiFormControl-marginNormal": {
      margin: "0",
    },
    "& .bottom-button-block": {
      display: "flex",
      justifyContent: "flex-end",
      "&.MuiDialogActions-root": {
        marginTop: "25px",
        padding: "0",
      },
      "& button": {
        height: "50px",
        lineHeight: "50px",
        fontWeight: "600",
        fontSize: "16px",
        minWidth: "165px",
        textTransform: "uppercase",
        "@media (max-width: 480px)": {
          minWidth: "100%",
          marginBottom: "15px",
          marginLeft: "0",
        },
      },
    },
    "& .info-driver": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      border: "1px solid #2196f3",
      backgroundColor: "#f4faff",
      borderRadius: "6px",
      marginBottom: "15px",
      padding: "10px 25px",
      fontSize: "16px",
      "& .info-driver-content": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start"
      }
    }
  },
  TableWrapper: {
    boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
    backgroundColor: colors.white,
    borderRadius: "6px",
    border: `1px solid ${colors.gray4}`,
    "& .MuiBackdrop-root": {
      color: " #fff",
      zIndex: "1201",
    },
  },
  customTable: {
    boxShadow: "none",
    "& .MuiTable-root": {
      minWidth: 1500,
      tableLayout: "fixed",
      "& .MuiTableCell-root": {
        fontWeight: 500,
        color: colors.black,
        border: "none",
      },
      "& .MuiTableHead-root": {
        boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
        backgroundColor: colors.white,
        "& .MuiTableCell-root": {
          color: "rgba(33, 33, 33, 0.7)",
          padding: "10px 19px",
          backgroundColor: colors.white,
          borderBottom: "1px solid #f4f4f4",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-root": {
          padding: "10px 19px",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
          "&.status": {
            "& span": {
              position: "relative",
              paddingLeft: 20,
              display: "block",
              "&:before": {
                content: '""',
                position: "absolute",
                backgroundColor: colors.black,
                height: 10,
                width: 10,
                borderRadius: "50%",
                left: 0,
                top: 7,
              },
            },
            "&.in-progress": {
              "& span": {
                color: colors.green,
                "&:before": {
                  backgroundColor: colors.green,
                },
              },
            },
            "&.assigned": {
              "& span": {
                color: colors.orange,
                "&:before": {
                  backgroundColor: colors.orange,
                },
              },
            },
          },
        },
      },
      "& .check": {
        width: "30px",
      },
      "& .jobId": {
        width: "80px",
        whiteSpace: "nowrap",
      },
      "& .city": {
        width: "80px",
      },
      "& .status": {
        width: "110px",
      },
      "& .driver": {
        width: "150px",
      },
      "& .customerName": {
        width: "170px",
      },
      "& .pickUpLocation": {
        width: "250px",
      },
      "& .dropOffLocation": {
        width: "250px",
      },
      "& .date": {
        width: "100px",
      },
    },
  },
});

export { SelectJobStyle };
